import {canCallApp} from '../utils.js';

const setCoachMark = (id, elem) => {
  if (!id || !elem || !canCallApp('tomaPunto')) return;
  const viewportOffset = elem.getBoundingClientRect();
  const params = {
    id: id,
    x: viewportOffset.left,
    y: viewportOffset.top
  }
  setTimeout(() => Trendier.tomaPunto(JSON.stringify(params)), 1); // setTimeOut para esperar a que el webkit de IOS esté cargado
};

export {setCoachMark};